import { Spin } from "antd";
import { showError, showSuccess } from "common/ToastNotifications";
import ViewsPageOrganism from "components/organisms/ViewsPage";
import AppPaths from "constants/appPaths";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

export class ViewsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filters: {},
            searchTerm: "",
            pendingDatasetNavId: null,
            loadError: null,
        };
    }

    componentDidMount() {
        this.props.getViewsList({});
        this.props.getUserViewResourcePermission();
        this.setState({ loading: true });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.getViewsListResult !== this.props.getViewsListResult) {
            if (this.props.getViewsListResult && !this.props.getViewsListResult.success) {
                const code = this.props.getViewsListResult.code;
                const message = code === "PERMISSION_DENIED"
                    ? "You do not have permission to view materialized views."
                    : "Failed to load views";

                this.setState({ loading: false, loadError: message });
                showError(message);
            } else if (this.props.viewsList?.pageKey) {
                this.props.getViewsList(this.state.filters, this.props.viewsList.pageKey, true);
            } else {
                this.setState({ loading: false, loadError: null });
            }
        }

        if (prevProps.deleteViewResult !== this.props.deleteViewResult) {
            if (this.props.deleteViewResult && this.props.deleteViewResult.success) {
                showSuccess("View deleted successfully");
            } else if (this.props.deleteViewResult && this.props.deleteViewResult.success === false) {
                showError("Failed to delete view");
            }
        }

        // Handle deferred navigation to source dataset
        if (
            this.state.pendingDatasetNavId &&
            prevProps.getDataSetByIdResult !== this.props.getDataSetByIdResult &&
            this.props.dataSet &&
            this.props.dataSet.dataSetId === this.state.pendingDatasetNavId
        ) {
            this.navigateToLoadedDataset(this.props.dataSet);
        }

        if (prevProps.runViewResult !== this.props.runViewResult) {
            if (this.props.runViewResult && this.props.runViewResult.success) {
                showSuccess("View execution started");
            } else if (this.props.runViewResult && this.props.runViewResult.success === false) {
                showError("Failed to start view execution");
            }
        }
    }

    onSearch = (searchTerm) => {
        let filters = { ...this.state.filters, search: searchTerm || undefined };
        this.setState({ filters, searchTerm, loading: true });
        this.props.getViewsList(filters);
    };

    onFilterChange = (key, value) => {
        let filters = { ...this.state.filters };
        if (value && value !== "all") {
            filters[key] = value;
        } else {
            delete filters[key];
        }
        this.setState({ filters, loading: true });
        this.props.getViewsList(filters);
    };

    onViewDetail = (viewId) => {
        const tenant = this.props.tenant;
        if (tenant) {
            this.props.history.push(
                AppPaths.TENANT_VIEW_DETAIL.replace(":tenant", tenant.name).replace(":viewId", viewId)
            );
        }
    };

    onCreateView = () => {
        const tenant = this.props.tenant;
        if (tenant) {
            this.props.history.push(
                AppPaths.TENANT_VIEW_CREATE.replace(":tenant", tenant.name)
            );
        }
    };

    onDeleteView = (viewId) => {
        this.props.deleteView(viewId);
    };

    onRunView = (viewId) => {
        this.props.runView(viewId);
    };

    onViewSourceDataset = (view) => {
        if (!this.props.tenant || !view) return;
        const { businessAreaId, sourceSchemaId, sourceDatasetId } = view;
        if (!businessAreaId || !sourceSchemaId || !sourceDatasetId) return;
        this.setState({ pendingDatasetNavId: sourceDatasetId });
        this.props.getDataSetById(businessAreaId, sourceSchemaId, sourceDatasetId);
    };

    navigateToLoadedDataset = (dataSet) => {
        const tenant = this.props.tenant;
        const dict = this.props.businessAreasDict || {};
        const bizArea = dict[dataSet.businessAreaId];
        const businessAreaName = (dataSet.businessAreaName || bizArea?.name || "").toLowerCase();
        const schemaName = (dataSet.schemaName || "").toLowerCase();
        this.setState({ pendingDatasetNavId: null });
        if (!tenant || !businessAreaName || !schemaName) {
            showError("Could not resolve source dataset location");
            return;
        }
        this.props.history.push(
            AppPaths.TENANT_SCHEMA_DATASET_ID_ACTION
                .replace(":tenant", tenant.name.toLowerCase())
                .replace(":businessarea", businessAreaName)
                .replace(":schema", schemaName)
                .replace(":dataSetId", dataSet.dataSetId)
                .replace(":dataSetAction", "view")
        );
    };

    render() {
        return (
            <Spin spinning={this.state.loading} size="large">
                <ViewsPageOrganism
                    views={this.props.viewsList?.Items || []}
                    searchTerm={this.state.searchTerm}
                    onSearch={this.onSearch}
                    onFilterChange={this.onFilterChange}
                    onViewDetail={this.onViewDetail}
                    onCreateView={this.onCreateView}
                    onDeleteView={this.onDeleteView}
                    onRunView={this.onRunView}
                    onViewSourceDataset={this.onViewSourceDataset}
                    loading={this.state.loading}
                    permission={this.props.resourcePermission}
                    loadError={this.state.loadError}
                />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    tenant: state.userLogin.tenant,
    viewsList: state.views.viewsListResult,
    getViewsListResult: state.views.getViewsListResult,
    deleteViewResult: state.views.deleteViewResult,
    runViewResult: state.views.runViewResult,
    resourcePermission: state.views.resourcePermission,
    dataSet: state.dataSets.dataSet,
    getDataSetByIdResult: state.dataSets.getDataSetByIdResult,
    businessAreasDict: state.home.businessAreasDict,
});

const mapDispatchToProps = (dispatch) => ({
    getViewsList: (filters, pageKey, append) => dispatch(actions.getViewsListRequest(filters, pageKey, append)),
    deleteView: (viewId) => dispatch(actions.deleteViewRequest(viewId)),
    runView: (viewId) => dispatch(actions.runViewRequest(viewId)),
    getUserViewResourcePermission: () => dispatch(actions.getUserViewResourcePermissionRequest()),
    getDataSetById: (businessAreaId, schemaId, dataSetId) =>
        dispatch(actions.getDataSetByIdRequest(businessAreaId, schemaId, dataSetId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewsPage));
